import React from "react";
import { ArrowRight } from "lucide-react";

interface ButtonProps {
  children: React.ReactNode;
  href: string;
  variant?: "primary" | "secondary";
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  href,
  variant = "primary",
  className = "",
}) => {
  const variants = {
    primary:
      "bg-brand-pink text-white shadow-[0_12px_26px_rgba(239,78,156,0.35)] hover:-translate-y-0.5 hover:bg-brand-pink-dark",
    secondary:
      "border border-zinc-300 bg-white text-zinc-900 hover:bg-brand-pink-soft",
  };

  return (
    <a
      href={href}
      className={`inline-flex items-center justify-center gap-2 rounded-md px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.08em] transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-pink focus-visible:ring-offset-2 ${variants[variant]} ${className}`}
    >
      <span>{children}</span>
      <ArrowRight className="h-4 w-4" aria-hidden="true" />
    </a>
  );
};

export default Button;
